<template>
  <div>
    <div class="row">
      <div class="mb-3 col-md">
        <treeselect
          instance-id="client"
          :model-value="clientValue"
          :auto-load-root-options="false"
          :placeholder="$t('Webportal.ClientFilter.Placeholder')"
          :options="clientItems"
          :disabled="disabledInternal"
          :disableFuzzyMatching="true"
          :multiple="multipleClientSelectionInternal"
          :disable-branch-nodes="!multipleClientSelectionInternal"
          :showCount="true"
          showCountOf="LEAF_DESCENDANTS"
          valueFormat="object"
          @close="loadData"
          @update:model-value="onClientChange"
        >
        </treeselect>
      </div>
      <div v-if="propertySelection" class="mb-3 col-md">
        <treeselect
          instance-id="property"
          :model-value="propertyValue"
          :auto-load-root-options="false"
          :placeholder="$t('Webportal.PropertyValueFilter.Placeholder')"
          :options="propertyItems"
          :disableFuzzyMatching="true"
          :disabled="disabledInternal || propertySelectDisabled || propertyItems.length === 0"
          :multiple="true"
          :showCount="true"
          showCountOf="LEAF_DESCENDANTS"
          :defaultExpandLevel="1"
          :disable-branch-nodes="false"
          value-consists-of="LEAF_PRIORITY"
          :limit="4"
          :limit-text="limitText"
          @close="loadData"
          @update:model-value="onPropertyChange"
        >
        </treeselect>
      </div>
    </div>
  </div>
</template>

<script>
import AppConfig from '@/mixins/AppConfig-APP_TARGET';
import SurveysService from '@/services/SurveysService';
import AdministrationService from '@/services/AdministrationService';

export default {
  name: "ClientFilter",

  mixins: [ AppConfig ],

  props: {
    modelValue: null,
    disabled: { default: false },
    multipleClientSelection: { default: true },
    propertySelection: { default: true },
    autoSelect: { default: false }
  },

  emits: ['update:model-value', 'disabledChanged'],

  data() {
    return {
      disabledInternal: this.disabled,
      multipleClientSelectionInternal: this.multipleClientSelection,

      clientValue: this.multipleClientSelectionInternal ? [] : null,
      clientItems: [],
      propertyItems: [],
      propertyValue: [],

      currentClientValue: null,
      currentFilter: null,
    }
  },

  computed: {
    waveSelectDisabled() {
      return !this.multipleClientSelectionInternal && _.isEmpty(this.clientValue);
    },

    scenarioSelectDisabled() {
      return !this.multipleClientSelectionInternal && _.isEmpty(this.clientValue);
    },

    propertySelectDisabled() {
      return _.isEmpty(this.clientValue);
    },

    filter() {
      if (!this.propertySelection && !this.multipleClientSelection) {
        return this.clientValue?.id;
      }

      return {
        clientIds: Array.isArray(this.clientValue)
            ? this.clientValue.map(item => item.id) :
            (this.clientValue ? [ this.clientValue.id ] : []),
        propertyIds: this.propertyValue,
        propertyUseLogicalAnd: false
      };
    },

    // ✅ Extrahiere clientId für externe Verwendung
    selectedClientId() {
      if (Array.isArray(this.clientValue) && this.clientValue.length > 0) {
        return this.clientValue[0].id;  // Erster Client bei Multiple-Selection
      }
      return this.clientValue?.id || null;
    }
  },

  watch: {
    currentFilter(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit("update:model-value", newVal);
      }
    },

    disabled(newVal, oldVal) {
      this.disabledInternal = newVal;
    },

    disabledInternal(newVal, oldVal) {
      this.$emit("disabledChanged", newVal);
    },
  },

  mounted() {
    this.getClients();
  },

  methods: {
    onClientChange(value) {
      this.clientValue = value;
      this.filterInput(value, "client");
    },

    onPropertyChange(value) {
      this.propertyValue = value;
      this.filterInput(value, "property");
    },

    getClients() {
      AdministrationService.getClientSettings()
        .then(response => {
          this.clientItems = response.data.map(item => {
              return { id: item.ClientId, label: item.ClientName };
          });

          if (this.autoSelect && this.clientItems.length === 1) {
            this.clientValue = this.clientItems[0];
            this.loadData();
          }
        })
    },

    getSurveyProperties() {
      if (!this.propertySelectDisabled) {
        this.propertyItems = [];
        SurveysService.getSurveyCustomProperties(this.filter, true)
          .then(response => {
            this.propertyItems = response.data;
          })
      }
    },

    // Called whenever the input of a treeselect control changes
    filterInput(value, instanceId) {
      // Workaround: Only call data loading when clear all is pressed
      if (_.size(value) === 0 || (!this.multipleClientSelection && instanceId == "client"))
        this.loadData();
    },

    // Applies changed filter and triggers data loading if necessary
    loadData() {
      // Only load data when effective filter has changed
      if (!_.isEqual(this.filter, this.currentFilter)) {
        let clientValueChanged = !_.isEqual(this.currentClientValue, this.clientValue);
        this.currentClientValue = this.clientValue;
        if (clientValueChanged) {
          this.propertyValue = [];
        }

        this.currentFilter = this.filter;

        if (clientValueChanged && this.propertySelection) {
          this.getSurveyProperties();
        }
      }
    },
  }
}
</script>
